"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationReasonOpportunity = exports.CancellationReasonLang = exports.CancellationReason = exports.CancellationReasonCategoryEnum = exports.CancellationReasonOnTopOrAlternativeEnum = exports.CancellationReasonVisibleForEnum = exports.CancellationReasonSourceEnum = exports.CancellationReasonForcesStatusEnum = exports.CancellationReasonForcesResultEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const invoicing_target_1 = require("./invoicing-target");
const documentation_type_1 = require("./documentation-type");
const job_status_enum_1 = require("./job-status-enum");
const opportunity_1 = require("./opportunity");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
const cancellation_reason_enums_1 = require("./cancellation-reason-enums");
var CancellationReasonForcesResultEnum;
(function (CancellationReasonForcesResultEnum) {
    CancellationReasonForcesResultEnum["NO"] = "no";
    CancellationReasonForcesResultEnum["POSITIVE"] = "positive";
    CancellationReasonForcesResultEnum["NEGATIVE"] = "negative";
})(CancellationReasonForcesResultEnum = exports.CancellationReasonForcesResultEnum || (exports.CancellationReasonForcesResultEnum = {}));
var PartialCancellationReasonForcesStatusEnum;
(function (PartialCancellationReasonForcesStatusEnum) {
    PartialCancellationReasonForcesStatusEnum["NONE"] = "none";
})(PartialCancellationReasonForcesStatusEnum || (PartialCancellationReasonForcesStatusEnum = {}));
exports.CancellationReasonForcesStatusEnum = {
    ...job_status_enum_1.JobStatusEnum,
    ...PartialCancellationReasonForcesStatusEnum,
};
exports.CancellationReasonSourceEnum = {
    ...invoicing_target_1.GeneralInvoicingTargetEnum,
};
var PartialCancellationReasonVisibleForEnum;
(function (PartialCancellationReasonVisibleForEnum) {
    PartialCancellationReasonVisibleForEnum["GID_FINANCE"] = "gid_finance";
})(PartialCancellationReasonVisibleForEnum || (PartialCancellationReasonVisibleForEnum = {}));
exports.CancellationReasonVisibleForEnum = {
    ...invoicing_target_1.GeneralInvoicingTargetEnum,
    ...PartialCancellationReasonVisibleForEnum,
};
var CancellationReasonOnTopOrAlternativeEnum;
(function (CancellationReasonOnTopOrAlternativeEnum) {
    CancellationReasonOnTopOrAlternativeEnum["NONE"] = "none";
    CancellationReasonOnTopOrAlternativeEnum["AND"] = "and";
    CancellationReasonOnTopOrAlternativeEnum["OR"] = "or";
})(CancellationReasonOnTopOrAlternativeEnum = exports.CancellationReasonOnTopOrAlternativeEnum || (exports.CancellationReasonOnTopOrAlternativeEnum = {}));
var CancellationReasonCategoryEnum;
(function (CancellationReasonCategoryEnum) {
    CancellationReasonCategoryEnum["JOB_SCOPE_CHANGE"] = "Jobanpassung";
    CancellationReasonCategoryEnum["POSTPONEMENT"] = "Terminverschiebung";
    CancellationReasonCategoryEnum["CANCELLATION"] = "Storno";
    CancellationReasonCategoryEnum["PARTNER_CHANGE"] = "Partnerwechsel";
    CancellationReasonCategoryEnum["PAUSE"] = "Pausierung";
    CancellationReasonCategoryEnum["STATUS_CHANGE"] = "Status\u00E4nderung";
    CancellationReasonCategoryEnum["REJECTION_PROPOSAL"] = "Rejection Proposal";
    CancellationReasonCategoryEnum["INVOICE_STORNO"] = "Rechnung Storno";
    CancellationReasonCategoryEnum["INVOICE_ORDER_NUMBER"] = "Rechnung Auftragsnummer";
    CancellationReasonCategoryEnum["INVOICE_AMOUNT"] = "Rechnung Betrag";
    CancellationReasonCategoryEnum["INVOICE_ADDRESS"] = "Rechnung Adresse";
    CancellationReasonCategoryEnum["INVOICE_TAX"] = "Rechnung Steuer";
    CancellationReasonCategoryEnum["INVOICE_LAYOUT"] = "Rechnung Layout";
    CancellationReasonCategoryEnum["INVOICE_TARGET"] = "Rechnung Ziel";
    CancellationReasonCategoryEnum["FOLLOW_UP_JOB"] = "Follow-up Job";
    CancellationReasonCategoryEnum["ADJUSTMENT_AFTER_PAYMENT"] = "Job/Rechnung Anpassung nach Zahlung";
    CancellationReasonCategoryEnum["INCOMPLETE_PROTOCOL"] = "Unvollst\u00E4ndiges Protokoll";
    CancellationReasonCategoryEnum["JOB_MULTIPLE_ADJUSTMENT"] = "Job Mehrfachanpassung";
    CancellationReasonCategoryEnum["PARTIAL_SELECTION"] = "Partial Selection";
})(CancellationReasonCategoryEnum = exports.CancellationReasonCategoryEnum || (exports.CancellationReasonCategoryEnum = {}));
let CancellationReason = class CancellationReason {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], CancellationReason.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Description('Human readable identifier, visually exposed in the admin app.'),
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 64,
        name: 'name',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.Description('Segment of the Modification action, used for visual grouping them in the Partner App'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(CancellationReasonCategoryEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CancellationReasonCategoryEnum,
        name: 'category',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "category", void 0);
__decorate([
    data_ui_1.DataUi.Description('Start of the availability of the CR in hours before the set appointment, 0 means not condition'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Show From (In Hours)' }),
    (0, typeorm_1.Column)('double precision', {
        name: 'show_from',
        default: 0,
    }),
    __metadata("design:type", Number)
], CancellationReason.prototype, "showFrom", void 0);
__decorate([
    data_ui_1.DataUi.Description('End of the availability of the CR in hours before the set appointment, 0 means not condition'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Show Until (In Hours)' }),
    (0, typeorm_1.Column)('double precision', {
        name: 'show_until',
        default: 0,
    }),
    __metadata("design:type", Number)
], CancellationReason.prototype, "showUntil", void 0);
__decorate([
    data_ui_1.DataUi.Description('What kind of documentation is required for applying the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(documentation_type_1.DocumentationTypeEnum),
    data_ui_1.DataUi.Override({ label: 'Documentation Type' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: documentation_type_1.DocumentationTypeEnum,
        default: documentation_type_1.DocumentationTypeEnum.NONE,
        name: 'documentation_type',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "documentationType", void 0);
__decorate([
    data_ui_1.DataUi.Description('Forces the "Forces Status" value to be applied on the jobin any case'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(CancellationReasonForcesResultEnum),
    data_ui_1.DataUi.Override({ label: 'Forces Result' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CancellationReasonForcesResultEnum,
        name: 'forces_result',
        default: CancellationReasonForcesResultEnum.NO,
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "forcesResult", void 0);
__decorate([
    data_ui_1.DataUi.Description('Target Status of the Job after applying the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(exports.CancellationReasonForcesStatusEnum),
    data_ui_1.DataUi.Override({ label: 'Forces Status' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: exports.CancellationReasonForcesStatusEnum,
        name: 'forces_status',
        default: exports.CancellationReasonForcesStatusEnum.NONE,
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "forcesStatus", void 0);
__decorate([
    data_ui_1.DataUi.Description('defines if customer signature is needed'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Sign Off' }),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        default: false,
        name: 'sign_off',
    }),
    __metadata("design:type", Boolean)
], CancellationReason.prototype, "signOff", void 0);
__decorate([
    data_ui_1.DataUi.Description('Job statuses in which the CR is available'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(job_status_enum_1.JobStatusEnum),
    data_ui_1.DataUi.Override({ label: 'Available For Status' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: job_status_enum_1.JobStatusEnum,
        name: 'available_for_status',
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], CancellationReason.prototype, "availableForStatus", void 0);
__decorate([
    data_ui_1.DataUi.Description('Which role is responsible for the appliction of the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(exports.CancellationReasonSourceEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: exports.CancellationReasonSourceEnum,
        name: 'source',
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], CancellationReason.prototype, "source", void 0);
__decorate([
    data_ui_1.DataUi.Description('For which role this CR is visible in the interface.'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(exports.CancellationReasonVisibleForEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: exports.CancellationReasonVisibleForEnum,
        name: 'visible_for',
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], CancellationReason.prototype, "visibleFor", void 0);
__decorate([
    data_ui_1.DataUi.Description('Defines if a date of delivery is needed to be provided with applying the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(cancellation_reason_enums_1.CancellationReasonDateFieldsEnum),
    data_ui_1.DataUi.Override({ label: 'Date Of Delivery' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'delivery_date_show',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "deliveryDateShow", void 0);
__decorate([
    data_ui_1.DataUi.Description('Defines if a date of readiness is needed to be provided with applying the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(cancellation_reason_enums_1.CancellationReasonDateFieldsEnum),
    data_ui_1.DataUi.Override({ label: 'Earliest Possible Installation Date' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'readiness_date_show',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "readinessDateShow", void 0);
__decorate([
    data_ui_1.DataUi.Description('Defines if a dates of availability are needed to be provided with applying the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(cancellation_reason_enums_1.CancellationReasonDateFieldsEnum),
    data_ui_1.DataUi.Override({ label: 'Desired Dates' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum,
        nullable: false,
        default: cancellation_reason_enums_1.CancellationReasonDateFieldsEnum.READ_ONLY,
        name: 'appointment_date_show',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "appointmentDateShow", void 0);
__decorate([
    data_ui_1.DataUi.Description('Free text field for providing more details about the CR'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Reason Variant' }),
    (0, typeorm_1.Column)('text', {
        default: '',
    }),
    __metadata("design:type", String)
], CancellationReason.prototype, "reasonVariant", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReason.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReason.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => CancellationReasonLang, (cancellationReasonLang) => cancellationReasonLang.cancellationReason),
    __metadata("design:type", Array)
], CancellationReason.prototype, "translations", void 0);
CancellationReason = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Cancellation Reason',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.Description('Normalized Job Modification Options, they need to be connectd to an Opportunity to be available.'),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('cancellation_reason', { schema: 'public' }),
    (0, typeorm_1.Unique)([
        'category',
        'showFrom',
        'showUntil',
        'documentationType',
        'forcesResult',
        'forcesStatus',
        'signOff',
        'availableForStatus',
        'source',
        'visibleFor',
        'reasonVariant',
    ])
], CancellationReason);
exports.CancellationReason = CancellationReason;
let CancellationReasonLang = class CancellationReasonLang {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], CancellationReasonLang.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 2,
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "locale", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'explanation',
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "explanation", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'label',
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "label", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'instructions',
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "instructions", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'description',
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "description", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Customer Description' }),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'customer_description',
    }),
    __metadata("design:type", String)
], CancellationReasonLang.prototype, "customerDescription", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Cancellation Reason' }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => CancellationReason),
    __metadata("design:type", CancellationReason)
], CancellationReasonLang.prototype, "cancellationReason", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonLang.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonLang.prototype, "updatedAt", void 0);
CancellationReasonLang = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Cancellation Reason Language',
        nameFunction: (i) => { var _a; return `${i.id}@${(_a = i.cancellationReason) === null || _a === void 0 ? void 0 : _a.name}`; },
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('cancellation_reason_lang', { schema: 'public' }),
    (0, typeorm_1.Unique)(['locale', 'cancellationReason'])
], CancellationReasonLang);
exports.CancellationReasonLang = CancellationReasonLang;
let CancellationReasonOpportunity = class CancellationReasonOpportunity {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], CancellationReasonOpportunity.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Cancellation Reason' }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => CancellationReason),
    __metadata("design:type", CancellationReason)
], CancellationReasonOpportunity.prototype, "cancellationReason", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity),
    __metadata("design:type", opportunity_1.Opportunity)
], CancellationReasonOpportunity.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Customer Communication' }),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        default: true,
        name: 'customer_communication',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonOpportunity.prototype, "customerCommunication", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Brand Communication' }),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        default: true,
        name: 'brand_communication',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonOpportunity.prototype, "brandCommunication", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Partner Communication' }),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        default: true,
        name: 'partner_communication',
    }),
    __metadata("design:type", Boolean)
], CancellationReasonOpportunity.prototype, "partnerCommunication", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Storno Percent' }),
    (0, typeorm_1.Column)('double precision', {
        name: 'storno_percent',
    }),
    __metadata("design:type", Number)
], CancellationReasonOpportunity.prototype, "stornoPercent", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'On Top Or Alternative' }),
    data_ui_1.DataUi.EnumValues(CancellationReasonOnTopOrAlternativeEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CancellationReasonOnTopOrAlternativeEnum,
        name: 'on_top_or_alternative',
        default: CancellationReasonOnTopOrAlternativeEnum.NONE,
    }),
    __metadata("design:type", String)
], CancellationReasonOpportunity.prototype, "onTopOrAlternative", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonOpportunity.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CancellationReasonOpportunity.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
        nullable: true,
    }),
    __metadata("design:type", Date)
], CancellationReasonOpportunity.prototype, "deletedAt", void 0);
CancellationReasonOpportunity = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Cancellation Reason Opportunity',
        nameFunction: (i) => { var _a, _b; return `${(_a = i.cancellationReason) === null || _a === void 0 ? void 0 : _a.name}@${(_b = i.opportunity) === null || _b === void 0 ? void 0 : _b.name}`; },
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('cancellation_reason_opportunity', { schema: 'public' }),
    (0, typeorm_1.Unique)([
        'cancellationReason',
        'opportunity',
        'customerCommunication',
        'brandCommunication',
        'partnerCommunication',
    ])
], CancellationReasonOpportunity);
exports.CancellationReasonOpportunity = CancellationReasonOpportunity;
//# sourceMappingURL=cancellation-reason.js.map